module.exports = __webpack_public_path__ + "img/i-share-line.b8f83d0a.svg";